import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    siteKey: String,
    action: String,
    freshToken: Boolean,
  };

  submit(e) {
    if (this.freshTokenValue) {
      return;
    }

    e.preventDefault();

    const form = this.element;
    const hiddenInput = form.querySelector(`#g-recaptcha-response-data-${this.actionValue}`);
    const response = new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(
          this.siteKeyValue,
          {
            action: this.actionValue,
          },
        ).then((token) => {
          resolve(token);
        }).catch((error) => {
          reject(error);
        });
      });
    });

    response.then((token) => {
      hiddenInput.value = token;
      this.freshTokenValue = true;
      form.requestSubmit();
    });
  }
}
